import { useEffect } from 'react';
function ScriptLoader({ isPremium, authenticated }) {
    function loadBuySellAdsScript() {
        const now = new Date();
        // Load the buysellads script with error escaping
        (function () {
            const bsa_optimize = window.document.createElement('script');
            bsa_optimize.type = 'text/javascript';
            bsa_optimize.async = true;
            bsa_optimize.src =
                'https://cdn4.buysellads.net/pub/pomofocus.js?' +
                    (now.getTime() - (now.getTime() % 600000));
            (window.document.getElementsByTagName('head')[0] ||
                window.document.getElementsByTagName('body')[0]).appendChild(bsa_optimize);
        })();
    }
    useEffect(() => {
        if (process.env.NODE_ENV === 'development')
            return;
        if (authenticated === undefined)
            return;
        if (isPremium)
            return;
        loadBuySellAdsScript();
    }, [authenticated]);
    return null;
}
export default ScriptLoader;
